class CustomDropdown {
    constructor() {
        this.dropdowns = document.querySelectorAll('.custom-dropdown__button');
        this.dropdownsButton = document.querySelectorAll('.custom-dropdown__lists button');
    }

    init() {
        if (this.dropdowns) {
            [...this.dropdowns].forEach(element => {
                element.addEventListener('click', (e) => this.dropdownsToggle(e));
            });
        }

        if (this.dropdownsButton) {
            [...this.dropdownsButton].forEach(element => {
                element.addEventListener('click', (e) => this.dropdownButton(e));
            });
        }

        document.addEventListener('click', (e) => {
            if (!e.target.closest('.custom-dropdown')) {
                this.closeDropdown(e);
            };
        })
    }

    dropdownsToggle(e) {
        e.preventDefault();

        if (e.target.parentElement.classList.contains('custom-dropdown--active')) {
            this.closeDropdown(e);
        } else {
            this.openDropdown(e);
        }
    }

    dropdownButton(e) {
        e.preventDefault();

        [...this.dropdownsButton].forEach(element => {
            element.classList.remove('active');
        });

        e.target.classList.add('active');

        const primaryButton = e.target.closest('.custom-dropdown').querySelector('.custom-dropdown__button');

        primaryButton.innerHTML = e.target.textContent;
        primaryButton.dataset.id = e.target.dataset.id;

        this.closeDropdown();
    }

    openDropdown(e) {
        e.target.parentElement.classList.add('custom-dropdown--active');
    }

    closeDropdown(e) {
        [...document.querySelectorAll('.custom-dropdown--active')].forEach(element => {
            element.classList.remove('custom-dropdown--active');
        });

    }
}

export default new CustomDropdown();